import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '../infrastructure/settings.api';

export const settingsKeys = {
  profile: ['settings', 'profile'] as const,
  clinic: ['settings', 'clinic'] as const,
  services: ['settings', 'services'] as const,
  rooms: ['settings', 'rooms'] as const,
  availability: ['settings', 'availability'] as const,
  account: ['settings', 'account'] as const,
  sessions: ['settings', 'sessions'] as const,
};

export const useClinicProfileQuery = (enabled = true) => useQuery({ queryKey: settingsKeys.profile, queryFn: settingsApi.getClinicProfile, enabled });
export const useClinicSettingsQuery = (enabled = true) => useQuery({ queryKey: settingsKeys.clinic, queryFn: settingsApi.getClinicSettings, enabled });
export const useIntakeFormQuery = (enabled = true) => useQuery({ queryKey: [...settingsKeys.clinic, 'intake-form'], queryFn: settingsApi.getIntakeForm, enabled });
export const useServicesQuery = (enabled = true) => useQuery({ queryKey: settingsKeys.services, queryFn: settingsApi.getServices, enabled });
export const useRoomsQuery = (enabled = true) => useQuery({ queryKey: settingsKeys.rooms, queryFn: settingsApi.getRooms, enabled });
export const useAvailabilityQuery = (enabled = true) => useQuery({ queryKey: settingsKeys.availability, queryFn: settingsApi.getAvailability, enabled });
export const useAccountSettingsQuery = () => useQuery({ queryKey: settingsKeys.account, queryFn: settingsApi.getAccountSettings });
export const useSessionsQuery = () => useQuery({ queryKey: settingsKeys.sessions, queryFn: settingsApi.getSessions });
